import { useStorage } from '#pplx/frontend/browser-storage/hooks/internal/useStorage.js';
import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
/**
 * A custom React hook that synchronizes state with sessionStorage using SafeSessionStorage.
 *
 * @template T - The type of the stored value
 * @param {string} key - The sessionStorage key
 * @param {T | (() => T)} initialValue - The initial value if no value exists in sessionStorage
 * @param {Omit<StorageOptions, 'global'>} options - `broadcast` (sync across hooks in the tab,
 *   default true). `global` is intentionally excluded: it's a localStorage-only concept
 *   (sessionStorage is already per-tab, never account-namespaced).
 * @returns {[T, (value: T | ((prev: T) => T)) => void]} A tuple containing the current value and a setter function and a remove function
 *
 * @example
 * const [isCollapsed, setIsCollapsed] = useSessionStorage<boolean>('sidebar-collapsed', false);
 * setIsCollapsed(true); // Updates both state and sessionStorage
 */
export const useSessionStorage = (key, initialValue, options = {}) => {
    return useStorage(key, initialValue, SafeSessionStorage, options);
};
//# sourceMappingURL=useSessionStorage.js.map